/* eslint-disable react/prop-types */
import Box from '@material-ui/core/Box'
import { MenuItem } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import Popover from '@material-ui/core/Popover'
import TextField from '@material-ui/core/TextField'
import Tooltip from '@material-ui/core/Tooltip'
import FilterListIcon from '@material-ui/icons/FilterList'
import SearchIcon from '@material-ui/icons/Search'
import PopupState, { bindPopover, bindTrigger } from 'material-ui-popup-state'
import React, { useState, useCallback } from 'react'
import { KeyboardDatePicker } from '@material-ui/pickers'
import { ValidatorForm } from 'react-material-ui-form-validator'
import { useDispatch, useSelector } from 'react-redux'
import { endOfDay, format, startOfDay } from 'date-fns'

import BadgeGlobal from '../../components/Badge'
import { fetchServicesRelatoryInit } from '../ServicesRelatoryActions'
import SelectField from '../../components/SelectField'

export default function Filter(props) {
  const items = useSelector(state => state.services_relatory.items)

  const attendances = useSelector(state => state.services_relatory.attendances)
  const services_status = useSelector(
    state => state.services_relatory.services_status
  )
  const companies = useSelector(state => state.services_relatory.companies)

  const dispatch = useDispatch()
  const { classes } = props
  const [form, setForm] = useState({
    attendance: '',
    date_start: new Date(),
    date_end: new Date(),
    service_status: '',
  })

  const updateField = useCallback(
    (name, value) => {
      setForm({ ...form, [name]: value })
    },
    [form]
  )

  const onSubmit = e => {
    e.preventDefault()
    const dateStart = form.date_start
      ? format(startOfDay(new Date(form.date_start)), 'yyyy-MM-dd HH:mm:ss')
      : null
    const dateEnd = form.date_end
      ? format(endOfDay(new Date(form.date_end)), 'yyyy-MM-dd HH:mm:ss')
      : null

    const data = {
      ...form,
      date_start: dateStart,
      date_end: dateEnd,
    }

    dispatch(fetchServicesRelatoryInit(null, data, null))
  }

  return (
    <Tooltip title="Filter list">
      <PopupState variant="popover" popupId="demo-popup-popover">
        {popupState => (
          <div>
            <IconButton aria-label="filter list" {...bindTrigger(popupState)}>
              <BadgeGlobal form={form} items={items}>
                <FilterListIcon />
              </BadgeGlobal>
            </IconButton>
            <Popover
              {...bindPopover(popupState)}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
            >
              <Box p={2} className={classes.popover}>
                <div className={classes.root}>
                  <ValidatorForm className={classes.form} onSubmit={onSubmit}>
                    <Grid
                      container
                      className={classes.gridContainer}
                      spacing={1}
                      justify="center"
                      alignItems="center"
                    >
                      <Grid item xs={6}>
                        <TextField
                          onChange={e =>
                            setForm({ ...form, attendance: e.target.value })
                          }
                          select
                          label="Atendente"
                          margin="dense"
                          variant="outlined"
                          className={classes.inputFilter}
                          fullWidth
                          value={form.attendance}
                        >
                          <MenuItem key="" value="">
                            Selecione...
                          </MenuItem>
                          {attendances?.map(attendance => (
                            <MenuItem key={attendance.id} value={attendance.id}>
                              {attendance.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>

                      <Grid item xs={6}>
                        <TextField
                          onChange={e =>
                            setForm({ ...form, service_status: e.target.value })
                          }
                          select
                          label="Status de Serviço"
                          className={classes.inputFilter}
                          margin="dense"
                          variant="outlined"
                          fullWidth
                          value={form.service_status}
                        >
                          <MenuItem key="" value="">
                            Selecione...
                          </MenuItem>
                          {services_status?.map(status => (
                            <MenuItem key={status.id} value={status.id}>
                              {status.name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>

                      <Grid item xs={6}>
                        <KeyboardDatePicker
                          clearable
                          value={form.date_start}
                          label="Data Inicial"
                          fullWidth
                          margin="dense"
                          inputVariant="outlined"
                          views={['date']}
                          clearLabel="Limpar"
                          invalidDateMessage="Data inválida"
                          autoOk
                          onChange={date =>
                            setForm({ ...form, date_start: date })
                          }
                          format="dd/MM/yyyy"
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <KeyboardDatePicker
                          clearable
                          value={form.date_end}
                          label="Data Final"
                          fullWidth
                          margin="dense"
                          inputVariant="outlined"
                          views={['date']}
                          clearLabel="Limpar"
                          invalidDateMessage="Data inválida"
                          autoOk
                          onChange={date =>
                            setForm({ ...form, date_end: date })
                          }
                          format="dd/MM/yyyy"
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <SelectField
                          style={{ marginTop: '0px' }}
                          options={companies}
                          setForm={updateField}
                          data={form.company || null}
                          name="company"
                          variant="outlined"
                          margin="dense"
                          label="Empresa"
                        />
                      </Grid>

                      <Grid item xs>
                        <Button
                          type="submit"
                          color="primary"
                          fullWidth
                          variant="contained"
                          className={classes.submit}
                          onClick={popupState.close}
                        >
                          <SearchIcon />
                          {` Filtrar`}
                        </Button>
                      </Grid>
                    </Grid>
                  </ValidatorForm>
                </div>
              </Box>
            </Popover>
          </div>
        )}
      </PopupState>
    </Tooltip>
  )
}
